import productSliderHtml from './productSlider.html';
import './productSlider.scss';

class ProductSliderDirective {
    constructor($window, $document, $rootScope) {
        this.restrict = 'A';
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$document = $document;
        this.template = productSliderHtml;
        this.transclude = true;
        this.replace = true;
        this.controllerAs = '$ctrl';
        this.bindToController = true;
        this.controller = ProductSliderDirectiveController;
        this.scope = {};
        this.attrsItems = '';
        this.debug = false;

        this.windowWidthItems = {
            '4.5': [
                {min: 0, max: 575, items: 1},
                {min: 576, max: 767, items: 2},
                {min: 768, max: 991, items: 3},
                {min: 992, max: null, items: 4.5}
            ],
            '4': [
                {min: 0, max: 575, items: 1},
                {min: 576, max: 767, items: 2},
                {min: 768, max: 991, items: 3},
                {min: 992, max: null, items: 4}
            ],
            '6': [
                {min: 0, max: 575, items: 1},
                {min: 576, max: 767, items: 2},
                {min: 768, max: 991, items: 4},
                {min: 992, max: null, items: 6}
            ],
            '6.5': [
                {min: 0, max: 575, items: 1},
                {min: 576, max: 767, items: 2},
                {min: 768, max: 991, items: 4},
                {min: 992, max: null, items: 6.5}
            ]
        }
        this.clickTimeout = null;
    }

    link(scope, element, attrs, controllers) {
        scope.totalImages = element[0].querySelectorAll('.product-slide').length;
        scope.attrsItems = parseFloat(attrs.items);
        scope.visibleImages = 0;
        scope.dragOffset = 0;
        scope.dragLength = 0;
        scope.dragTime = 0;

        scope.$watch(
            () => element[0].querySelectorAll('.product-slide').length,
            (newVal, oldVal) => {
                scope.totalImages = newVal;
                scope.attrsItems = parseFloat(attrs.items);
                initSlider(false);
                scope.onSliderChange();
            });

        const onResize = (event) => {
            initSlider(true);
            scope.onSliderChange();
        }

        const initSlider = (applyScope = true) => {
            const mediaData = this.windowWidthItems[scope.attrsItems];
            if (!mediaData) {
                return;
            }
            mediaData.forEach(media => {
                let mediaQuery = [];
                if (media.min) {
                    mediaQuery.push('(min-width: ' + media.min + 'px)');
                }
                if (media.max) {
                    mediaQuery.push('(max-width: ' + media.max + 'px)');
                }
                mediaQuery = mediaQuery.join(' and ');
                if (this.$window.matchMedia(mediaQuery).matches) {
                    if (scope.visibleImages === media.items) {
                        return;
                    }
                    scope.visibleImages = media.items;
                    if (applyScope) {
                        scope.$apply();
                    }
                }
            });
        }

        const disabled = () => {
            return scope.totalImages <= scope.visibleImages;
        }

        const touchStart = (event) => {
            if (disabled()) {
                return;
            }

            scope.dragCurrentPositionX = scope.dragStartPositionX = this.getEventPositionX(event);
            scope.dragStartPositionY = this.getEventPositionY(event);
            scope.dragTime = (new Date()).getTime();
            this.$document.on('touchmove', touchMove);
            this.$document.on('touchend', touchEnd);
            this.$document.on('dragend', touchEnd);
            this.$document.on('drag', touchMove);
            clearTimeout(this.clickTimeout);
            element.addClass('dragging');
        }

        const touchMove = (event) => {
            if (disabled()) {
                return;
            }

            let eventX = this.getEventPositionX(event);
            if (eventX === 0) {
                return;
            }
            scope.dragOffset = this.getEventPositionX(event) - scope.dragStartPositionX;
            scope.dragLength = Math.sqrt(Math.pow(this.getEventPositionX(event) - scope.dragStartPositionX, 2) + Math.pow(this.getEventPositionY(event) - scope.dragStartPositionY, 2));
            clearTimeout(this.clickTimeout);
            scope.$apply();
        }

        const touchEnd = (event) => {
            if (disabled()) {
                return;
            }

            if (this.debug) {
                console.log('touchEnd', scope.dragOffset, scope.dragLength, (new Date()).getTime() - scope.dragTime);
            }

            event.preventDefault();
            this.$document.unbind('touchmove');
            this.$document.unbind('touchend');
            this.$document.unbind('drag');
            this.$document.unbind('dragend');

            if (scope.dragLength < 20 && (new Date()).getTime() - scope.dragTime < 150) {
                if (event.changedTouches.length > 0 && event.changedTouches[0].target) {
                    if (event.changedTouches[0].target.tagName === 'BUTTON') {
                        event.changedTouches[0].target.click();
                    } else if(event.changedTouches[0].target.parentElement.tagName === 'BUTTON') {
                        event.changedTouches[0].target.parentElement.click();
                    } else if (event.changedTouches[0].target.classList.contains('product-link')) {
                        event.changedTouches[0].target.classList.add('active');
                        this.clickTimeout = setTimeout(() => {
                            document.location.href = event.changedTouches[0].target.getAttribute('href');
                        }, 100);
                    } else if (event.changedTouches[0].target.classList.contains('product-slider-left')) {
                        controllers.prev();
                    } else if (event.changedTouches[0].target.classList.contains('product-slider-right')) {
                        controllers.next();
                    }
                }
            }

            const containerWidth = element[0].clientWidth;
            const elementWidth = containerWidth / scope.visibleImages;
            const partialOffset = (Math.abs(scope.dragOffset / elementWidth)) - Math.floor(Math.abs(scope.dragOffset / elementWidth));

            let imageShift = null;
            let direction = scope.dragOffset < 0 ? 1 : -1;

            if (partialOffset > 0.2) {
                imageShift = Math.ceil(Math.abs(scope.dragOffset / elementWidth));
            } else {
                imageShift = Math.floor(Math.abs(scope.dragOffset / elementWidth));
            }

            controllers.setCurrentImage(controllers.currentImage + direction * imageShift);

            scope.dragOffset = 0;
            scope.dragLength = 0;
            element.removeClass('dragging');
            scope.$apply();
        }

        element.on('touchstart', touchStart);
        element.on('dragstart', touchStart);

        angular.element(this.$window).on('resize', onResize);

        initSlider(false);
    }

    getEventPositionX(event) {
        if (event.constructor.name === 'TouchEvent') {
            return event.targetTouches[0].pageX;
        }

        return event.clientX;
    }

    getEventPositionY(event) {
        if (event.constructor.name === 'TouchEvent') {
            return event.targetTouches[0].pageY;
        }

        return event.clientY;
    }

    static directiveFactory($window, $document, $rootScope) {
        'ngInject';
        return new ProductSliderDirective($window, $document, $rootScope);
    }
}

class ProductSliderDirectiveController {
    constructor($scope, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.autoPlay = null;
        this.currentImage = 1;
        this.$scope.onSliderChange = () => {
            this.currentImage = 1;
        }
    }

    $onInit() {
    }

    get sliderOffset() {
        return `calc(${-(this.currentImage - 1) * (100 / this.$scope.visibleImages)}% + ${this.$scope.dragOffset}px)`;
    }

    get hasMoreToShow() {
        return this.currentImage + Math.floor(this.$scope.visibleImages) <= this.$scope.totalImages;
    }

    setCurrentImage(currentImage) {
        if (currentImage < 1) {
            currentImage = 1;
        } else if (currentImage + Math.floor(this.$scope.visibleImages) > this.$scope.totalImages) {
            currentImage = 1 + this.$scope.totalImages - Math.floor(this.$scope.visibleImages);
        }
        this.currentImage = currentImage;
    }

    prev() {
        this.currentImage--;
    }

    next() {
        this.currentImage++;
    }

}

export default ProductSliderDirective;
